import React, { useState, useEffect, useCallback, } from 'react';
import { Container, } from 'react-bootstrap';
import Header from './header.jsx';
import Speech from './speech.jsx';
import Pricing from './pricing.jsx';
import Profile from './profile.jsx';
import LoginCheck from './login_check';
import Cookie from 'universal-cookie';
import { apiUrl_api, baseUrl, } from './url.jsx';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const cookie = new Cookie();


function App() {
  const [loginInfo, setLoginInfo] = useState({});   // 登录信息
  const [headerItem, setHeaderItem] = useState('home');
  
  const [showProfile, setShowProfile] = useState(false)  // 是否显示个人资料弹窗
  const [showLoginCheck, setShowLoginCheck] = useState(false)  // 是否显示登录检查弹窗

  const [isMobile, setIsMobile] = useState(false);  // 判断是否手机登录

  const cookie_loginInfo = cookie.get('login-info');
  console.log(cookie);
  console.log(cookie_loginInfo);

  useEffect (() => {
    console.log("31" , cookie_loginInfo);
    // 读取缓存中登录信息
    if(cookie_loginInfo && Object.keys(cookie_loginInfo).length>0) {     
      console.log("logged",cookie_loginInfo);
      setLoginInfo(cookie_loginInfo);
      
    } else {    // 如果缓存没有记录，读取后端记录
      console.log("not login");
      const bodyData = {url: baseUrl}
      fetch(apiUrl_api + "/login/get_uid", {        
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bodyData),
        keepalive: true,
        credentials: "include", // 允许发送 cookie
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if(data.uid) {
          const newData = {...data, islogin: true};
          setLoginInfo(newData);
          handleCookie(newData);
        }
      })
      .catch(error => {
          console.error(error);
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };    
  },[])

  const handleResize = () => {
    if(
      (window.innerHeight < 1024 && window.innerWidth < 768) ||
      (window.innerWidth < 768 && window.innerHeight < 1024)
    )
    setIsMobile(true);   // 根据屏幕大小判断是否手机登录
  };

  const handelCheckLgoin = useCallback(() => {    
    if (loginInfo.islogin) {  // 如果已经登录，则显示个人资料弹窗
        setShowProfile(true);
    } else {  // 如果未登录，则显示登录检查弹窗
        setShowLoginCheck(true);
    }
  });

  // 关闭登录检查弹窗
  const handleLoginModalClose = (userInfo) => {
    setShowLoginCheck(false);  
    handleCookie(userInfo);
  };

  // 关闭个人资料弹窗
  const handleProfileModalClose = (islogout) => {
    if(islogout) {
      setLoginInfo({});   // 如果点击 logout，清除 loginInfo
    }
    setShowProfile(false);
  };
  
  // 写入 cookie
  const handleCookie = (userInfo) => {
    const tenYearsLater = new Date();
    tenYearsLater.setFullYear(tenYearsLater.getFullYear() + 10);
    cookie.set('login-info', userInfo, { expires: tenYearsLater, path: '/' });

    setLoginInfo(userInfo);
  };

  return (
    <Container>
      <Header loginInfo={loginInfo}
        onHeaderItemSelected = {setHeaderItem}
        onCheckLogin = {handelCheckLgoin}
      ></Header>

      { headerItem.toLowerCase() === "home" && 
        <Speech loginInfo={loginInfo} isMobile={isMobile} onCheckLogin = {handelCheckLgoin} /> }

      { headerItem.toLowerCase() === "pricing" && <Pricing loginInfo={loginInfo} /> }

      { showProfile && 
        <Profile uid={loginInfo.uid} onModalClose={handleProfileModalClose} /> }

      { showLoginCheck && 
        <LoginCheck isMobile={isMobile} onModalClose={handleLoginModalClose} /> } 
    </Container>
  );
}

export default App;